import React, { useEffect } from 'react';
import { connect,useDispatch } from 'react-redux';
import { compose } from 'redux';
import {getDataOnRequest} from '../redux/actions/CommonActions'
import { toast } from 'react-toastify';
const FltLicenseContainer = (OriginalComponent) => {
  const NewComponent = (props) => {
    const dispatch = useDispatch();
    useEffect(()=>{
      toast.dismiss();
      if(props.userAuth.users_access_token && Object.keys(props.fltLicences).length === 0)
        dispatch(getDataOnRequest(props.userAuth.users_access_token,'SetFltLicense','SET_FLT_LICENSES'))
          
   }, [props.userAuth.users_access_token, props.fltLicences, dispatch])

    return (
      <OriginalComponent {...props}  />
    )
  }
  return NewComponent
}

const mapStateToProps = (state) => {
  return {
    fltLicences:state.fltLicences.fltLicences,
    userAuth:state.auth.authUserData,
    userInfo:state.userProfile.userData
  };
};

const composedFltLicenseContainer = compose(connect(mapStateToProps), FltLicenseContainer)
export default composedFltLicenseContainer;

